export const giftPotScope = 'app.containers.giftPot';

export const giftPotMessages = {
  metaTitle: {
    id: `${giftPotScope}.metaTitle`,
    defaultMessage: 'Cagnotte voyage : un cadeau à plusieurs',
    en: 'Travel gift pot: a gift from several people',
    es: 'Bote de viaje: un regalo entre varios',
    it: 'Colletta viaggio: un regalo di gruppo',
    de: 'Reise-Sammelkasse: ein Geschenk von mehreren',
    nl: 'Reispot: een cadeau van meerdere mensen',
  },
  metaDescription: {
    id: `${giftPotScope}.metaDescription`,
    defaultMessage:
      'Pot de départ, anniversaire, mariage : créez une cagnotte, chacun participe dès 10 € et le bénéficiaire reçoit une carte cadeau Tictactrip avec tous les messages.',
    en: 'Farewell, birthday, wedding: create a pot, everyone chips in from €10 and the recipient gets a Tictactrip gift card with every message.',
    es: 'Despedida, cumpleaños, boda: cree un bote, cada uno participa desde 10 € y la persona recibe una tarjeta regalo Tictactrip con todos los mensajes.',
    it: "Festa d'addio, compleanno, matrimonio: crea una colletta, ognuno partecipa da 10 € e il festeggiato riceve una carta regalo Tictactrip con tutti i messaggi.",
    de: 'Abschied, Geburtstag, Hochzeit: Starten Sie eine Sammelkasse, jeder gibt ab 10 €, und die beschenkte Person erhält eine Tictactrip-Geschenkkarte mit allen Nachrichten.',
    nl: 'Afscheid, verjaardag, bruiloft: start een pot, iedereen doet mee vanaf € 10 en de ontvanger krijgt een Tictactrip-cadeaukaart met alle berichten.',
  },
  eyebrow: {
    id: `${giftPotScope}.eyebrow`,
    defaultMessage: 'Cagnotte voyage',
    en: 'Travel gift pot',
    es: 'Bote de viaje',
    it: 'Colletta viaggio',
    de: 'Reise-Sammelkasse',
    nl: 'Reispot',
  },
  createTitle: {
    id: `${giftPotScope}.createTitle`,
    defaultMessage: 'Un cadeau à plusieurs : offrez un voyage',
    en: 'A gift from several people: give a trip',
    es: 'Un regalo entre varios: regale un viaje',
    it: 'Un regalo di gruppo: regala un viaggio',
    de: 'Ein Geschenk von mehreren: Verschenken Sie eine Reise',
    nl: 'Een cadeau van meerdere mensen: geef een reis',
  },
  createText: {
    id: `${giftPotScope}.createText`,
    defaultMessage:
      'Créez la cagnotte, partagez le lien, chacun participe dès 10 €. À la date choisie, le bénéficiaire reçoit une carte cadeau du montant total, avec tous les messages.',
    en: 'Create the pot, share the link, everyone chips in from €10. On the chosen date, the recipient gets a gift card for the full amount, with every message.',
    es: 'Cree el bote, comparta el enlace, cada uno participa desde 10 €. En la fecha elegida, la persona recibe una tarjeta regalo por el importe total, con todos los mensajes.',
    it: "Crea la colletta, condividi il link, ognuno partecipa da 10 €. Alla data scelta, il festeggiato riceve una carta regalo dell'importo totale, con tutti i messaggi.",
    de: 'Starten Sie die Sammelkasse, teilen Sie den Link, jeder gibt ab 10 €. Am gewählten Tag erhält die beschenkte Person eine Geschenkkarte über den Gesamtbetrag, mit allen Nachrichten.',
    nl: 'Start de pot, deel de link, iedereen doet mee vanaf € 10. Op de gekozen datum krijgt de ontvanger een cadeaukaart voor het totale bedrag, met alle berichten.',
  },
  step1: {
    id: `${giftPotScope}.step1`,
    defaultMessage: "1. L'occasion",
    en: '1. The occasion',
    es: '1. La ocasión',
    it: "1. L'occasione",
    de: '1. Der Anlass',
    nl: '1. De gelegenheid',
  },
  titleLabel: {
    id: `${giftPotScope}.titleLabel`,
    defaultMessage: 'Titre de la cagnotte',
    en: 'Title of the pot',
    es: 'Título del bote',
    it: 'Titolo della colletta',
    de: 'Titel der Sammelkasse',
    nl: 'Titel van de pot',
  },
  introLabel: {
    id: `${giftPotScope}.introLabel`,
    defaultMessage: 'Un mot pour les participants (facultatif)',
    en: 'A word for the participants (optional)',
    es: 'Un mensaje para los participantes (opcional)',
    it: 'Un messaggio per i partecipanti (facoltativo)',
    de: 'Ein Wort an die Teilnehmenden (optional)',
    nl: 'Een woord voor de deelnemers (optioneel)',
  },
  step2: {
    id: `${giftPotScope}.step2`,
    defaultMessage: '2. Pour qui ?',
    en: '2. For whom?',
    es: '2. ¿Para quién?',
    it: '2. Per chi?',
    de: '2. Für wen?',
    nl: '2. Voor wie?',
  },
  toNameLabel: {
    id: `${giftPotScope}.toNameLabel`,
    defaultMessage: 'Prénom du bénéficiaire',
    en: "Recipient's first name",
    es: 'Nombre de la persona',
    it: 'Nome del festeggiato',
    de: 'Vorname der beschenkten Person',
    nl: 'Voornaam van de ontvanger',
  },
  toEmailLabel: {
    id: `${giftPotScope}.toEmailLabel`,
    defaultMessage: 'Son email',
    en: 'Their email',
    es: 'Su email',
    it: 'La sua email',
    de: 'Ihre E-Mail',
    nl: 'Diens e-mail',
  },
  noEmail: {
    id: `${giftPotScope}.noEmail`,
    defaultMessage:
      "Je n'ai pas son email : je recevrai la carte pour l'imprimer et la lui remettre.",
    en: "I don't have their email: I'll receive the card to print and hand it over.",
    es: 'No tengo su email: recibiré la tarjeta para imprimirla y entregarla.',
    it: 'Non ho la sua email: riceverò la carta da stampare e consegnare.',
    de: 'Ich habe die E-Mail nicht: Ich erhalte die Karte zum Ausdrucken und Überreichen.',
    nl: 'Ik heb het e-mailadres niet: ik ontvang de kaart om af te drukken en te overhandigen.',
  },
  step3: {
    id: `${giftPotScope}.step3`,
    defaultMessage: '3. Le thème de la carte',
    en: "3. The card's theme",
    es: '3. El tema de la tarjeta',
    it: '3. Il tema della carta',
    de: '3. Das Motiv der Karte',
    nl: '3. Het thema van de kaart',
  },
  step4: {
    id: `${giftPotScope}.step4`,
    defaultMessage: '4. La remise',
    en: '4. The handover',
    es: '4. La entrega',
    it: '4. La consegna',
    de: '4. Die Übergabe',
    nl: '4. De overhandiging',
  },
  dateLabel: {
    id: `${giftPotScope}.dateLabel`,
    defaultMessage: 'Date de remise',
    en: 'Handover date',
    es: 'Fecha de entrega',
    it: 'Data di consegna',
    de: 'Datum der Übergabe',
    nl: 'Datum van overhandiging',
  },
  timeLabel: {
    id: `${giftPotScope}.timeLabel`,
    defaultMessage: 'Heure (heure de Paris)',
    en: 'Time (Paris time)',
    es: 'Hora (hora de París)',
    it: 'Ora (ora di Parigi)',
    de: 'Uhrzeit (Pariser Zeit)',
    nl: 'Tijd (Parijse tijd)',
  },
  dateHint: {
    id: `${giftPotScope}.dateHint`,
    defaultMessage:
      'Vous pourrez clôturer plus tôt depuis votre suivi, ou changer la date.',
    en: 'You can close it earlier from your follow-up page, or change the date.',
    es: 'Podrá cerrarlo antes desde su seguimiento, o cambiar la fecha.',
    it: 'Potrà chiuderla prima dal suo monitoraggio, o cambiare la data.',
    de: 'Sie können sie in Ihrer Übersicht früher schließen oder das Datum ändern.',
    nl: 'U kunt de pot eerder sluiten via uw overzicht, of de datum wijzigen.',
  },
  goalLabel: {
    id: `${giftPotScope}.goalLabel`,
    defaultMessage: 'Objectif en € (facultatif)',
    en: 'Goal in € (optional)',
    es: 'Objetivo en € (opcional)',
    it: 'Obiettivo in € (facoltativo)',
    de: 'Ziel in € (optional)',
    nl: 'Doel in € (optioneel)',
  },
  amountLegend: {
    id: `${giftPotScope}.amountLegend`,
    defaultMessage: 'Montant collecté',
    en: 'Amount collected',
    es: 'Importe recaudado',
    it: 'Importo raccolto',
    de: 'Gesammelter Betrag',
    nl: 'Ingezameld bedrag',
  },
  amountVisible: {
    id: `${giftPotScope}.amountVisible`,
    defaultMessage: 'Visible par tous',
    en: 'Visible to everyone',
    es: 'Visible para todos',
    it: 'Visibile a tutti',
    de: 'Für alle sichtbar',
    nl: 'Zichtbaar voor iedereen',
  },
  amountVisibleHint: {
    id: `${giftPotScope}.amountVisibleHint`,
    defaultMessage: '« 340 € collectés sur 400 € »',
    en: '“€340 collected of €400”',
    es: '«340 € recaudados de 400 €»',
    it: '«340 € raccolti su 400 €»',
    de: '„340 € von 400 € gesammelt“',
    nl: '‘€ 340 ingezameld van € 400’',
  },
  amountHidden: {
    id: `${giftPotScope}.amountHidden`,
    defaultMessage: 'Visible par moi seul',
    en: 'Visible to me only',
    es: 'Visible solo para mí',
    it: 'Visibile solo a me',
    de: 'Nur für mich sichtbar',
    nl: 'Alleen zichtbaar voor mij',
  },
  amountHiddenHint: {
    id: `${giftPotScope}.amountHiddenHint`,
    defaultMessage: 'Les participants voient le nombre de participants',
    en: 'Participants see how many people took part',
    es: 'Los participantes ven el número de participantes',
    it: 'I partecipanti vedono il numero di partecipanti',
    de: 'Teilnehmende sehen die Zahl der Teilnehmenden',
    nl: 'Deelnemers zien het aantal deelnemers',
  },
  step5: {
    id: `${giftPotScope}.step5`,
    defaultMessage: '5. Vous',
    en: '5. You',
    es: '5. Usted',
    it: '5. Lei',
    de: '5. Sie',
    nl: '5. U',
  },
  organizerNameLabel: {
    id: `${giftPotScope}.organizerNameLabel`,
    defaultMessage: 'Votre prénom',
    en: 'Your first name',
    es: 'Su nombre',
    it: 'Il suo nome',
    de: 'Ihr Vorname',
    nl: 'Uw voornaam',
  },
  organizerEmailLabel: {
    id: `${giftPotScope}.organizerEmailLabel`,
    defaultMessage: 'Votre email (suivi et lien de partage)',
    en: 'Your email (follow-up and share link)',
    es: 'Su email (seguimiento y enlace para compartir)',
    it: 'La sua email (monitoraggio e link da condividere)',
    de: 'Ihre E-Mail (Übersicht und Link zum Teilen)',
    nl: 'Uw e-mail (overzicht en deellink)',
  },
  freeText: {
    id: `${giftPotScope}.freeText`,
    defaultMessage:
      'La création est gratuite. Vous participez comme les autres, depuis la page de la cagnotte.',
    en: "Creating it is free. You chip in like everyone else, from the pot's page.",
    es: 'La creación es gratuita. Usted participa como los demás, desde la página del bote.',
    it: 'La creazione è gratuita. Lei partecipa come gli altri, dalla pagina della colletta.',
    de: 'Das Anlegen ist kostenlos. Sie geben wie alle anderen über die Seite der Sammelkasse.',
    nl: 'Aanmaken is gratis. U doet mee zoals de anderen, via de pagina van de pot.',
  },
  create: {
    id: `${giftPotScope}.create`,
    defaultMessage: 'Créer la cagnotte',
    en: 'Create the pot',
    es: 'Crear el bote',
    it: 'Crea la colletta',
    de: 'Sammelkasse anlegen',
    nl: 'Pot aanmaken',
  },
  createLegal: {
    id: `${giftPotScope}.createLegal`,
    defaultMessage:
      'Chaque participation achète une part de la carte cadeau Tictactrip.',
    en: 'Each contribution buys a share of the Tictactrip gift card.',
    es: 'Cada participación compra una parte de la tarjeta regalo Tictactrip.',
    it: 'Ogni partecipazione acquista una parte della carta regalo Tictactrip.',
    de: 'Jeder Beitrag kauft einen Anteil der Tictactrip-Geschenkkarte.',
    nl: 'Elke bijdrage koopt een deel van de Tictactrip-cadeaukaart.',
  },
  preview: {
    id: `${giftPotScope}.preview`,
    defaultMessage: 'Aperçu de la page partagée',
    en: 'Preview of the shared page',
    es: 'Vista previa de la página compartida',
    it: 'Anteprima della pagina condivisa',
    de: 'Vorschau der geteilten Seite',
    nl: 'Voorbeeld van de gedeelde pagina',
  },
  createError: {
    id: `${giftPotScope}.createError`,
    defaultMessage:
      "La cagnotte n'a pas pu être créée. Vérifiez les champs et réessayez.",
    en: 'The pot could not be created. Check the fields and try again.',
    es: 'No se pudo crear el bote. Revise los campos e inténtelo de nuevo.',
    it: 'Non è stato possibile creare la colletta. Controlli i campi e riprovi.',
    de: 'Die Sammelkasse konnte nicht angelegt werden. Prüfen Sie die Felder und versuchen Sie es erneut.',
    nl: 'De pot kon niet worden aangemaakt. Controleer de velden en probeer opnieuw.',
  },
  invalidField: {
    id: `${giftPotScope}.invalidField`,
    defaultMessage: "Un champ manque ou n'est pas valable.",
    en: 'A field is missing or not valid.',
    es: 'Falta un campo o no es válido.',
    it: 'Un campo manca o non è valido.',
    de: 'Ein Feld fehlt oder ist ungültig.',
    nl: 'Een veld ontbreekt of is ongeldig.',
  },
  occasionDepart: {
    id: `${giftPotScope}.occasionDepart`,
    defaultMessage: 'Pot de départ',
    en: 'Farewell',
    es: 'Despedida',
    it: "Festa d'addio",
    de: 'Abschied',
    nl: 'Afscheid',
  },
  occasionAnniversaire: {
    id: `${giftPotScope}.occasionAnniversaire`,
    defaultMessage: 'Anniversaire',
    en: 'Birthday',
    es: 'Cumpleaños',
    it: 'Compleanno',
    de: 'Geburtstag',
    nl: 'Verjaardag',
  },
  occasionMariage: {
    id: `${giftPotScope}.occasionMariage`,
    defaultMessage: 'Mariage',
    en: 'Wedding',
    es: 'Boda',
    it: 'Matrimonio',
    de: 'Hochzeit',
    nl: 'Bruiloft',
  },
  occasionNaissance: {
    id: `${giftPotScope}.occasionNaissance`,
    defaultMessage: 'Naissance',
    en: 'New baby',
    es: 'Nacimiento',
    it: 'Nascita',
    de: 'Geburt',
    nl: 'Geboorte',
  },
  occasionRetraite: {
    id: `${giftPotScope}.occasionRetraite`,
    defaultMessage: 'Retraite',
    en: 'Retirement',
    es: 'Jubilación',
    it: 'Pensione',
    de: 'Ruhestand',
    nl: 'Pensioen',
  },
  occasionNoel: {
    id: `${giftPotScope}.occasionNoel`,
    defaultMessage: 'Noël',
    en: 'Christmas',
    es: 'Navidad',
    it: 'Natale',
    de: 'Weihnachten',
    nl: 'Kerstmis',
  },
  occasionAutre: {
    id: `${giftPotScope}.occasionAutre`,
    defaultMessage: 'Autre',
    en: 'Other',
    es: 'Otra',
    it: 'Altro',
    de: 'Anderer',
    nl: 'Andere',
  },
  titleDepart: {
    id: `${giftPotScope}.titleDepart`,
    defaultMessage: 'Pot de départ de {name}',
    en: "{name}'s farewell",
    es: 'Despedida de {name}',
    it: "Festa d'addio di {name}",
    de: 'Abschied von {name}',
    nl: 'Afscheid van {name}',
  },
  titleAnniversaire: {
    id: `${giftPotScope}.titleAnniversaire`,
    defaultMessage: 'Anniversaire de {name}',
    en: "{name}'s birthday",
    es: 'Cumpleaños de {name}',
    it: 'Compleanno di {name}',
    de: 'Geburtstag von {name}',
    nl: 'Verjaardag van {name}',
  },
  titleMariage: {
    id: `${giftPotScope}.titleMariage`,
    defaultMessage: 'Voyage de noces de {name}',
    en: "{name}'s honeymoon",
    es: 'Viaje de novios de {name}',
    it: 'Viaggio di nozze di {name}',
    de: 'Hochzeitsreise von {name}',
    nl: 'Huwelijksreis van {name}',
  },
  titleNaissance: {
    id: `${giftPotScope}.titleNaissance`,
    defaultMessage: 'Bienvenue au bébé de {name}',
    en: "Welcome to {name}'s baby",
    es: 'Bienvenida al bebé de {name}',
    it: 'Benvenuto al bebè di {name}',
    de: 'Willkommen, Baby von {name}',
    nl: 'Welkom aan de baby van {name}',
  },
  titleRetraite: {
    id: `${giftPotScope}.titleRetraite`,
    defaultMessage: 'Retraite de {name}',
    en: "{name}'s retirement",
    es: 'Jubilación de {name}',
    it: 'Pensione di {name}',
    de: 'Ruhestand von {name}',
    nl: 'Pensioen van {name}',
  },
  titleNoel: {
    id: `${giftPotScope}.titleNoel`,
    defaultMessage: 'Noël de {name}',
    en: "{name}'s Christmas",
    es: 'Navidad de {name}',
    it: 'Natale di {name}',
    de: 'Weihnachten für {name}',
    nl: 'Kerstmis van {name}',
  },
  titleAutre: {
    id: `${giftPotScope}.titleAutre`,
    defaultMessage: 'Cagnotte pour {name}',
    en: 'Gift pot for {name}',
    es: 'Bote para {name}',
    it: 'Colletta per {name}',
    de: 'Sammelkasse für {name}',
    nl: 'Pot voor {name}',
  },
  occasionEyebrow: {
    id: `${giftPotScope}.occasionEyebrow`,
    defaultMessage: 'Cagnotte · {occasion}',
    en: 'Gift pot · {occasion}',
    es: 'Bote · {occasion}',
    it: 'Colletta · {occasion}',
    de: 'Sammelkasse · {occasion}',
    nl: 'Pot · {occasion}',
  },
  collected: {
    id: `${giftPotScope}.collected`,
    defaultMessage: '{total} collectés sur {goal}',
    en: '{total} collected of {goal}',
    es: '{total} recaudados de {goal}',
    it: '{total} raccolti su {goal}',
    de: '{total} von {goal} gesammelt',
    nl: '{total} ingezameld van {goal}',
  },
  collectedNoGoal: {
    id: `${giftPotScope}.collectedNoGoal`,
    defaultMessage: '{total} collectés',
    en: '{total} collected',
    es: '{total} recaudados',
    it: '{total} raccolti',
    de: '{total} gesammelt',
    nl: '{total} ingezameld',
  },
  count: {
    id: `${giftPotScope}.count`,
    defaultMessage:
      '{count, plural, one {# participant} other {# participants}}',
    en: '{count, plural, one {# participant} other {# participants}}',
    es: '{count, plural, one {# participante} other {# participantes}}',
    it: '{count, plural, one {# partecipante} other {# partecipanti}}',
    de: '{count, plural, one {# Teilnehmer} other {# Teilnehmende}}',
    nl: '{count, plural, one {# deelnemer} other {# deelnemers}}',
  },
  deliverLine: {
    id: `${giftPotScope}.deliverLine`,
    defaultMessage: 'remise le {date}',
    en: 'handed over on {date}',
    es: 'entrega el {date}',
    it: 'consegna il {date}',
    de: 'Übergabe am {date}',
    nl: 'overhandiging op {date}',
  },
  participate: {
    id: `${giftPotScope}.participate`,
    defaultMessage: 'Participer',
    en: 'Chip in',
    es: 'Participar',
    it: 'Partecipa',
    de: 'Mitmachen',
    nl: 'Meedoen',
  },
  copyLink: {
    id: `${giftPotScope}.copyLink`,
    defaultMessage: 'Copier le lien',
    en: 'Copy the link',
    es: 'Copiar el enlace',
    it: 'Copia il link',
    de: 'Link kopieren',
    nl: 'Link kopiëren',
  },
  linkCopied: {
    id: `${giftPotScope}.linkCopied`,
    defaultMessage: 'Lien copié',
    en: 'Link copied',
    es: 'Enlace copiado',
    it: 'Link copiato',
    de: 'Link kopiert',
    nl: 'Link gekopieerd',
  },
  shareText: {
    id: `${giftPotScope}.shareText`,
    defaultMessage: 'Participe à la cagnotte « {title} » : {url}',
    en: 'Chip in to the gift pot “{title}”: {url}',
    es: 'Participa en el bote «{title}»: {url}',
    it: 'Partecipa alla colletta «{title}»: {url}',
    de: 'Mach mit bei der Sammelkasse „{title}“: {url}',
    nl: 'Doe mee aan de pot ‘{title}’: {url}',
  },
  wordsTitle: {
    id: `${giftPotScope}.wordsTitle`,
    defaultMessage: 'Les mots pour {name}',
    en: 'The messages for {name}',
    es: 'Los mensajes para {name}',
    it: 'I messaggi per {name}',
    de: 'Die Nachrichten für {name}',
    nl: 'De berichten voor {name}',
  },
  wordsText: {
    id: `${giftPotScope}.wordsText`,
    defaultMessage:
      '{name} les découvrira le jour de la remise, avec la carte.',
    en: '{name} will discover them on the day, with the card.',
    es: '{name} los descubrirá el día de la entrega, con la tarjeta.',
    it: '{name} li scoprirà il giorno della consegna, con la carta.',
    de: '{name} entdeckt sie am Tag der Übergabe, mit der Karte.',
    nl: '{name} ontdekt ze op de dag van overhandiging, samen met de kaart.',
  },
  noWords: {
    id: `${giftPotScope}.noWords`,
    defaultMessage: 'Soyez le premier à participer !',
    en: 'Be the first to chip in!',
    es: '¡Sea el primero en participar!',
    it: 'Sia il primo a partecipare!',
    de: 'Seien Sie der Erste, der mitmacht!',
    nl: 'Wees de eerste die meedoet!',
  },
  anonymous: {
    id: `${giftPotScope}.anonymous`,
    defaultMessage: 'Un participant',
    en: 'A participant',
    es: 'Un participante',
    it: 'Un partecipante',
    de: 'Ein Teilnehmer',
    nl: 'Een deelnemer',
  },
  amountMasked: {
    id: `${giftPotScope}.amountMasked`,
    defaultMessage: 'montant masqué',
    en: 'amount hidden',
    es: 'importe oculto',
    it: 'importo nascosto',
    de: 'Betrag verborgen',
    nl: 'bedrag verborgen',
  },
  howTitle: {
    id: `${giftPotScope}.howTitle`,
    defaultMessage: 'Comment ça marche',
    en: 'How it works',
    es: 'Cómo funciona',
    it: 'Come funziona',
    de: "So funktioniert's",
    nl: 'Zo werkt het',
  },
  howText: {
    id: `${giftPotScope}.howText`,
    defaultMessage:
      "Votre participation achète une part d'une carte cadeau Tictactrip. Le {date}, {name} reçoit la carte avec le total : des trajets en train ou en bus, en France et en Europe, en plusieurs fois pendant 1 an. Si la cagnotte est annulée avant, chacun est remboursé.",
    en: 'Your contribution buys a share of a Tictactrip gift card. On {date}, {name} gets the card with the total: train or bus trips in France and Europe, usable several times for 1 year. If the pot is cancelled before, everyone is refunded.',
    es: 'Su participación compra una parte de una tarjeta regalo Tictactrip. El {date}, {name} recibe la tarjeta con el total: trayectos en tren o autobús, en Francia y Europa, en varias veces durante 1 año. Si el bote se cancela antes, todos son reembolsados.',
    it: 'La sua partecipazione acquista una parte di una carta regalo Tictactrip. Il {date}, {name} riceve la carta con il totale: viaggi in treno o autobus, in Francia e in Europa, utilizzabile più volte per 1 anno. Se la colletta viene annullata prima, tutti sono rimborsati.',
    de: 'Ihr Beitrag kauft einen Anteil einer Tictactrip-Geschenkkarte. Am {date} erhält {name} die Karte mit dem Gesamtbetrag: Zug- oder Busreisen in Frankreich und Europa, 1 Jahr lang mehrfach nutzbar. Wird die Sammelkasse vorher abgesagt, erhält jeder sein Geld zurück.',
    nl: 'Uw bijdrage koopt een deel van een Tictactrip-cadeaukaart. Op {date} krijgt {name} de kaart met het totaal: trein- of busreizen in Frankrijk en Europa, 1 jaar lang meerdere keren te gebruiken. Wordt de pot eerder geannuleerd, dan krijgt iedereen zijn geld terug.',
  },
  otherAmount: {
    id: `${giftPotScope}.otherAmount`,
    defaultMessage: 'Ou un autre montant (de 10 à 500 €)',
    en: 'Or another amount (€10 to €500)',
    es: 'U otro importe (de 10 a 500 €)',
    it: 'Oppure un altro importo (da 10 a 500 €)',
    de: 'Oder ein anderer Betrag (10 bis 500 €)',
    nl: 'Of een ander bedrag (€ 10 tot € 500)',
  },
  amountError: {
    id: `${giftPotScope}.amountError`,
    defaultMessage: 'La participation va de 10 à 500 €.',
    en: 'A contribution is from €10 to €500.',
    es: 'La participación va de 10 a 500 €.',
    it: 'La partecipazione va da 10 a 500 €.',
    de: 'Ein Beitrag liegt zwischen 10 und 500 €.',
    nl: 'Een bijdrage is van € 10 tot € 500.',
  },
  nameLabel: {
    id: `${giftPotScope}.nameLabel`,
    defaultMessage: 'Votre nom, tel que {name} le verra',
    en: 'Your name, as {name} will see it',
    es: 'Su nombre, tal como {name} lo verá',
    it: 'Il suo nome, come lo vedrà {name}',
    de: 'Ihr Name, wie {name} ihn sehen wird',
    nl: 'Uw naam, zoals {name} die ziet',
  },
  messageLabel: {
    id: `${giftPotScope}.messageLabel`,
    defaultMessage: 'Votre mot pour {name} (facultatif)',
    en: 'Your message for {name} (optional)',
    es: 'Su mensaje para {name} (opcional)',
    it: 'Il suo messaggio per {name} (facoltativo)',
    de: 'Ihre Nachricht an {name} (optional)',
    nl: 'Uw bericht voor {name} (optioneel)',
  },
  emailLabel: {
    id: `${giftPotScope}.emailLabel`,
    defaultMessage: 'Votre email (pour le reçu)',
    en: 'Your email (for the receipt)',
    es: 'Su email (para el recibo)',
    it: 'La sua email (per la ricevuta)',
    de: 'Ihre E-Mail (für die Quittung)',
    nl: 'Uw e-mail (voor het betaalbewijs)',
  },
  hideAmount: {
    id: `${giftPotScope}.hideAmount`,
    defaultMessage: 'Masquer mon montant',
    en: 'Hide my amount',
    es: 'Ocultar mi importe',
    it: 'Nascondi il mio importo',
    de: 'Meinen Betrag verbergen',
    nl: 'Mijn bedrag verbergen',
  },
  anonymousLabel: {
    id: `${giftPotScope}.anonymousLabel`,
    defaultMessage: 'Participer sans afficher mon nom',
    en: 'Chip in without showing my name',
    es: 'Participar sin mostrar mi nombre',
    it: 'Partecipa senza mostrare il mio nome',
    de: 'Mitmachen, ohne meinen Namen zu zeigen',
    nl: 'Meedoen zonder mijn naam te tonen',
  },
  pay: {
    id: `${giftPotScope}.pay`,
    defaultMessage: 'Payer {amount}',
    en: 'Pay {amount}',
    es: 'Pagar {amount}',
    it: 'Paga {amount}',
    de: '{amount} bezahlen',
    nl: '{amount} betalen',
  },
  paid: {
    id: `${giftPotScope}.paid`,
    defaultMessage:
      'Merci ! Votre participation de {amount} est enregistrée. Votre reçu arrive par email.',
    en: 'Thank you! Your contribution of {amount} is recorded. Your receipt is on its way by email.',
    es: '¡Gracias! Su participación de {amount} está registrada. Su recibo llega por email.',
    it: 'Grazie! La sua partecipazione di {amount} è registrata. La ricevuta arriva via email.',
    de: 'Danke! Ihr Beitrag von {amount} ist erfasst. Ihre Quittung kommt per E-Mail.',
    nl: 'Bedankt! Uw bijdrage van {amount} is geregistreerd. Uw betaalbewijs komt per e-mail.',
  },
  payLegal: {
    id: `${giftPotScope}.payLegal`,
    defaultMessage: 'Paiement sécurisé par carte bancaire.',
    en: 'Secure payment by bank card.',
    es: 'Pago seguro con tarjeta bancaria.',
    it: 'Pagamento sicuro con carta bancaria.',
    de: 'Sichere Zahlung per Bankkarte.',
    nl: 'Veilige betaling met bankkaart.',
  },
  closed: {
    id: `${giftPotScope}.closed`,
    defaultMessage:
      'Cette cagnotte est clôturée : la carte a été remise à {name}.',
    en: 'This pot is closed: the card was handed to {name}.',
    es: 'Este bote está cerrado: la tarjeta se entregó a {name}.',
    it: 'Questa colletta è chiusa: la carta è stata consegnata a {name}.',
    de: 'Diese Sammelkasse ist geschlossen: Die Karte wurde {name} übergeben.',
    nl: 'Deze pot is gesloten: de kaart is aan {name} overhandigd.',
  },
  cancelled: {
    id: `${giftPotScope}.cancelled`,
    defaultMessage:
      'Cette cagnotte a été annulée. Les participants sont remboursés.',
    en: 'This pot was cancelled. The participants are refunded.',
    es: 'Este bote se canceló. Los participantes son reembolsados.',
    it: 'Questa colletta è stata annullata. I partecipanti sono rimborsati.',
    de: 'Diese Sammelkasse wurde abgesagt. Die Teilnehmenden erhalten ihr Geld zurück.',
    nl: 'Deze pot is geannuleerd. De deelnemers worden terugbetaald.',
  },
  notFound: {
    id: `${giftPotScope}.notFound`,
    defaultMessage: "Cette cagnotte n'existe pas. Vérifiez le lien.",
    en: 'This pot does not exist. Check the link.',
    es: 'Este bote no existe. Revise el enlace.',
    it: 'Questa colletta non esiste. Controlli il link.',
    de: 'Diese Sammelkasse gibt es nicht. Prüfen Sie den Link.',
    nl: 'Deze pot bestaat niet. Controleer de link.',
  },
  paymentFailed: {
    id: `${giftPotScope}.paymentFailed`,
    defaultMessage: "Le paiement n'a pas abouti. Aucun montant n'a été débité.",
    en: 'The payment did not go through. Nothing was charged.',
    es: 'El pago no se completó. No se ha cobrado nada.',
    it: 'Il pagamento non è andato a buon fine. Non è stato addebitato nulla.',
    de: 'Die Zahlung ist fehlgeschlagen. Es wurde nichts abgebucht.',
    nl: 'De betaling is niet gelukt. Er is niets afgeschreven.',
  },
  contributeError: {
    id: `${giftPotScope}.contributeError`,
    defaultMessage:
      "La participation n'a pas pu être enregistrée. Réessayez dans un instant.",
    en: 'The contribution could not be recorded. Try again in a moment.',
    es: 'No se pudo registrar la participación. Inténtelo de nuevo en un momento.',
    it: 'Non è stato possibile registrare la partecipazione. Riprovi tra un istante.',
    de: 'Der Beitrag konnte nicht erfasst werden. Versuchen Sie es gleich noch einmal.',
    nl: 'De bijdrage kon niet worden geregistreerd. Probeer het zo opnieuw.',
  },
  waitConfirmation: {
    id: `${giftPotScope}.waitConfirmation`,
    defaultMessage: 'Nous attendons la confirmation de votre banque…',
    en: "Waiting for your bank's confirmation…",
    es: 'Esperando la confirmación de su banco…',
    it: 'In attesa della conferma della sua banca…',
    de: 'Wir warten auf die Bestätigung Ihrer Bank…',
    nl: 'Wachten op de bevestiging van uw bank…',
  },
  organizerTitle: {
    id: `${giftPotScope}.organizerTitle`,
    defaultMessage: 'Suivi de la cagnotte',
    en: 'Gift pot follow-up',
    es: 'Seguimiento del bote',
    it: 'Monitoraggio della colletta',
    de: 'Übersicht der Sammelkasse',
    nl: 'Overzicht van de pot',
  },
  organizerOnly: {
    id: `${giftPotScope}.organizerOnly`,
    defaultMessage:
      'Vous seul voyez cette page. Le lien de suivi est dans votre email de création.',
    en: 'Only you can see this page. The follow-up link is in your creation email.',
    es: 'Solo usted ve esta página. El enlace de seguimiento está en su email de creación.',
    it: 'Solo lei vede questa pagina. Il link di monitoraggio è nella sua email di creazione.',
    de: 'Nur Sie sehen diese Seite. Der Link steht in Ihrer Bestätigungs-E-Mail.',
    nl: 'Alleen u ziet deze pagina. De link staat in uw aanmaakmail.',
  },
  seePage: {
    id: `${giftPotScope}.seePage`,
    defaultMessage: 'Voir la page des participants',
    en: "See the participants' page",
    es: 'Ver la página de los participantes',
    it: 'Vedi la pagina dei partecipanti',
    de: 'Seite der Teilnehmenden ansehen',
    nl: 'Pagina van de deelnemers bekijken',
  },
  statusOpen: {
    id: `${giftPotScope}.statusOpen`,
    defaultMessage: 'Ouverte',
    en: 'Open',
    es: 'Abierto',
    it: 'Aperta',
    de: 'Offen',
    nl: 'Open',
  },
  statusClosed: {
    id: `${giftPotScope}.statusClosed`,
    defaultMessage: 'Clôturée, carte envoyée',
    en: 'Closed, card sent',
    es: 'Cerrado, tarjeta enviada',
    it: 'Chiusa, carta inviata',
    de: 'Geschlossen, Karte gesendet',
    nl: 'Gesloten, kaart verzonden',
  },
  statusCancelled: {
    id: `${giftPotScope}.statusCancelled`,
    defaultMessage: 'Annulée',
    en: 'Cancelled',
    es: 'Cancelado',
    it: 'Annullata',
    de: 'Abgesagt',
    nl: 'Geannuleerd',
  },
  closedNotice: {
    id: `${giftPotScope}.closedNotice`,
    defaultMessage:
      'La cagnotte est clôturée : {name} a reçu sa carte de {total} avec les messages.',
    en: 'The pot is closed: {name} received the {total} card with the messages.',
    es: 'El bote está cerrado: {name} recibió su tarjeta de {total} con los mensajes.',
    it: 'La colletta è chiusa: {name} ha ricevuto la carta da {total} con i messaggi.',
    de: 'Die Sammelkasse ist geschlossen: {name} hat die Karte über {total} mit den Nachrichten erhalten.',
    nl: 'De pot is gesloten: {name} heeft de kaart van {total} met de berichten ontvangen.',
  },
  closedNoticePrint: {
    id: `${giftPotScope}.closedNoticePrint`,
    defaultMessage:
      "La cagnotte est clôturée : la carte de {total} et le livre d'or vous ont été envoyés pour les imprimer.",
    en: 'The pot is closed: the {total} card and the guest book were sent to you to print.',
    es: 'El bote está cerrado: la tarjeta de {total} y el libro de visitas se le enviaron para imprimirlos.',
    it: 'La colletta è chiusa: la carta da {total} e il libro degli ospiti le sono stati inviati da stampare.',
    de: 'Die Sammelkasse ist geschlossen: Karte über {total} und Gästebuch wurden Ihnen zum Ausdrucken gesendet.',
    nl: 'De pot is gesloten: de kaart van {total} en het gastenboek zijn u toegestuurd om af te drukken.',
  },
  cancelledNotice: {
    id: `${giftPotScope}.cancelledNotice`,
    defaultMessage:
      'La cagnotte est annulée. Les participants sont remboursés sur leur carte bancaire sous 5 à 10 jours.',
    en: 'The pot is cancelled. Participants are refunded on their bank card within 5 to 10 days.',
    es: 'El bote está cancelado. Los participantes son reembolsados en su tarjeta en 5 a 10 días.',
    it: 'La colletta è annullata. I partecipanti sono rimborsati sulla carta entro 5-10 giorni.',
    de: 'Die Sammelkasse ist abgesagt. Die Teilnehmenden erhalten ihr Geld in 5 bis 10 Tagen auf ihre Bankkarte zurück.',
    nl: 'De pot is geannuleerd. Deelnemers worden binnen 5 tot 10 dagen op hun bankkaart terugbetaald.',
  },
  kpiCollected: {
    id: `${giftPotScope}.kpiCollected`,
    defaultMessage: 'Collecté',
    en: 'Collected',
    es: 'Recaudado',
    it: 'Raccolto',
    de: 'Gesammelt',
    nl: 'Ingezameld',
  },
  kpiGoal: {
    id: `${giftPotScope}.kpiGoal`,
    defaultMessage: 'objectif {goal}',
    en: 'goal {goal}',
    es: 'objetivo {goal}',
    it: 'obiettivo {goal}',
    de: 'Ziel {goal}',
    nl: 'doel {goal}',
  },
  kpiCount: {
    id: `${giftPotScope}.kpiCount`,
    defaultMessage: 'Participants',
    en: 'Participants',
    es: 'Participantes',
    it: 'Partecipanti',
    de: 'Teilnehmende',
    nl: 'Deelnemers',
  },
  kpiDelivery: {
    id: `${giftPotScope}.kpiDelivery`,
    defaultMessage: 'Remise',
    en: 'Handover',
    es: 'Entrega',
    it: 'Consegna',
    de: 'Übergabe',
    nl: 'Overhandiging',
  },
  kpiDeliveryTo: {
    id: `${giftPotScope}.kpiDeliveryTo`,
    defaultMessage: 'par email à {email}',
    en: 'by email to {email}',
    es: 'por email a {email}',
    it: 'via email a {email}',
    de: 'per E-Mail an {email}',
    nl: 'per e-mail naar {email}',
  },
  kpiDeliveryPrint: {
    id: `${giftPotScope}.kpiDeliveryPrint`,
    defaultMessage: 'chez vous, à imprimer',
    en: 'to you, to print',
    es: 'a usted, para imprimir',
    it: 'a lei, da stampare',
    de: 'an Sie, zum Ausdrucken',
    nl: 'naar u, om af te drukken',
  },
  hide: {
    id: `${giftPotScope}.hide`,
    defaultMessage: 'Le masquer',
    en: 'Hide it',
    es: 'Ocultarlo',
    it: 'Nascondilo',
    de: 'Verbergen',
    nl: 'Verbergen',
  },
  show: {
    id: `${giftPotScope}.show`,
    defaultMessage: 'Le montrer',
    en: 'Show it',
    es: 'Mostrarlo',
    it: 'Mostralo',
    de: 'Anzeigen',
    nl: 'Tonen',
  },
  colDate: {
    id: `${giftPotScope}.colDate`,
    defaultMessage: 'Date',
    en: 'Date',
    es: 'Fecha',
    it: 'Data',
    de: 'Datum',
    nl: 'Datum',
  },
  colName: {
    id: `${giftPotScope}.colName`,
    defaultMessage: 'Participant',
    en: 'Participant',
    es: 'Participante',
    it: 'Partecipante',
    de: 'Teilnehmer',
    nl: 'Deelnemer',
  },
  colWord: {
    id: `${giftPotScope}.colWord`,
    defaultMessage: 'Mot',
    en: 'Message',
    es: 'Mensaje',
    it: 'Messaggio',
    de: 'Nachricht',
    nl: 'Bericht',
  },
  colAmount: {
    id: `${giftPotScope}.colAmount`,
    defaultMessage: 'Montant',
    en: 'Amount',
    es: 'Importe',
    it: 'Importo',
    de: 'Betrag',
    nl: 'Bedrag',
  },
  shareTitle: {
    id: `${giftPotScope}.shareTitle`,
    defaultMessage: 'Partager',
    en: 'Share',
    es: 'Compartir',
    it: 'Condividi',
    de: 'Teilen',
    nl: 'Delen',
  },
  deliveryTitle: {
    id: `${giftPotScope}.deliveryTitle`,
    defaultMessage: 'La remise',
    en: 'The handover',
    es: 'La entrega',
    it: 'La consegna',
    de: 'Die Übergabe',
    nl: 'De overhandiging',
  },
  dateTimeLabel: {
    id: `${giftPotScope}.dateTimeLabel`,
    defaultMessage: 'Date et heure',
    en: 'Date and time',
    es: 'Fecha y hora',
    it: 'Data e ora',
    de: 'Datum und Uhrzeit',
    nl: 'Datum en tijd',
  },
  changeDate: {
    id: `${giftPotScope}.changeDate`,
    defaultMessage: 'Changer la date',
    en: 'Change the date',
    es: 'Cambiar la fecha',
    it: 'Cambia la data',
    de: 'Datum ändern',
    nl: 'Datum wijzigen',
  },
  closeNow: {
    id: `${giftPotScope}.closeNow`,
    defaultMessage: 'Clôturer et envoyer la carte maintenant',
    en: 'Close and send the card now',
    es: 'Cerrar y enviar la tarjeta ahora',
    it: 'Chiudi e invia la carta ora',
    de: 'Schließen und Karte jetzt senden',
    nl: 'Sluiten en de kaart nu versturen',
  },
  closeHint: {
    id: `${giftPotScope}.closeHint`,
    defaultMessage:
      'Plus personne ne pourra participer. {name} reçoit la carte de {total} tout de suite.',
    en: 'Nobody will be able to chip in any more. {name} gets the {total} card right away.',
    es: 'Nadie podrá participar. {name} recibe la tarjeta de {total} enseguida.',
    it: 'Nessuno potrà più partecipare. {name} riceve subito la carta da {total}.',
    de: 'Niemand kann mehr mitmachen. {name} erhält die Karte über {total} sofort.',
    nl: 'Niemand kan nog meedoen. {name} krijgt de kaart van {total} meteen.',
  },
  cancelTitle: {
    id: `${giftPotScope}.cancelTitle`,
    defaultMessage: 'Annuler la cagnotte',
    en: 'Cancel the pot',
    es: 'Cancelar el bote',
    it: 'Annulla la colletta',
    de: 'Sammelkasse absagen',
    nl: 'Pot annuleren',
  },
  cancelHint: {
    id: `${giftPotScope}.cancelHint`,
    defaultMessage:
      "Chaque participant est remboursé sur sa carte bancaire. Possible tant que la carte n'est pas envoyée.",
    en: 'Each participant is refunded on their bank card. Possible until the card is sent.',
    es: 'Cada participante es reembolsado en su tarjeta. Posible hasta que se envíe la tarjeta.',
    it: 'Ogni partecipante è rimborsato sulla sua carta. Possibile finché la carta non è inviata.',
    de: 'Jeder erhält sein Geld auf die Bankkarte zurück. Möglich, bis die Karte gesendet ist.',
    nl: 'Elke deelnemer wordt terugbetaald op zijn bankkaart. Mogelijk tot de kaart is verzonden.',
  },
  cancelButton: {
    id: `${giftPotScope}.cancelButton`,
    defaultMessage: 'Annuler et rembourser',
    en: 'Cancel and refund',
    es: 'Cancelar y reembolsar',
    it: 'Annulla e rimborsa',
    de: 'Absagen und erstatten',
    nl: 'Annuleren en terugbetalen',
  },
  confirmClose: {
    id: `${giftPotScope}.confirmClose`,
    defaultMessage: 'Clôturer la cagnotte et envoyer la carte maintenant ?',
    en: 'Close the pot and send the card now?',
    es: '¿Cerrar el bote y enviar la tarjeta ahora?',
    it: 'Chiudere la colletta e inviare la carta ora?',
    de: 'Sammelkasse schließen und Karte jetzt senden?',
    nl: 'De pot sluiten en de kaart nu versturen?',
  },
  confirmCancel: {
    id: `${giftPotScope}.confirmCancel`,
    defaultMessage: 'Annuler la cagnotte et rembourser tous les participants ?',
    en: 'Cancel the pot and refund every participant?',
    es: '¿Cancelar el bote y reembolsar a todos los participantes?',
    it: 'Annullare la colletta e rimborsare tutti i partecipanti?',
    de: 'Sammelkasse absagen und allen das Geld erstatten?',
    nl: 'De pot annuleren en alle deelnemers terugbetalen?',
  },
  notify: {
    id: `${giftPotScope}.notify`,
    defaultMessage: "M'envoyer un email à chaque participation",
    en: 'Email me at each contribution',
    es: 'Enviarme un email en cada participación',
    it: "Inviami un'email a ogni partecipazione",
    de: 'Bei jedem Beitrag eine E-Mail senden',
    nl: 'Mij bij elke bijdrage een e-mail sturen',
  },
  actionError: {
    id: `${giftPotScope}.actionError`,
    defaultMessage: "L'action n'a pas abouti. Réessayez dans un instant.",
    en: 'The action did not go through. Try again in a moment.',
    es: 'La acción no se completó. Inténtelo de nuevo en un momento.',
    it: "L'azione non è andata a buon fine. Riprovi tra un istante.",
    de: 'Die Aktion ist fehlgeschlagen. Versuchen Sie es gleich noch einmal.',
    nl: 'De actie is niet gelukt. Probeer het zo opnieuw.',
  },
  invalidLink: {
    id: `${giftPotScope}.invalidLink`,
    defaultMessage:
      "Ce lien n'est pas valable. Utilisez celui de votre email de création.",
    en: 'This link is not valid. Use the one in your creation email.',
    es: 'Este enlace no es válido. Use el de su email de creación.',
    it: 'Questo link non è valido. Usi quello della sua email di creazione.',
    de: 'Dieser Link ist ungültig. Verwenden Sie den aus Ihrer Bestätigungs-E-Mail.',
    nl: 'Deze link is niet geldig. Gebruik die uit uw aanmaakmail.',
  },
  landingTitle: {
    id: `${giftPotScope}.landingTitle`,
    defaultMessage: 'Un cadeau à plusieurs ?',
    en: 'A gift from several people?',
    es: '¿Un regalo entre varios?',
    it: 'Un regalo di gruppo?',
    de: 'Ein Geschenk von mehreren?',
    nl: 'Een cadeau van meerdere mensen?',
  },
  landingText: {
    id: `${giftPotScope}.landingText`,
    defaultMessage:
      'Pot de départ, anniversaire, mariage : créez une cagnotte, chacun participe dès 10 €, et le bénéficiaire reçoit une seule carte avec tous les messages.',
    en: 'Farewell, birthday, wedding: create a pot, everyone chips in from €10, and the recipient gets one card with every message.',
    es: 'Despedida, cumpleaños, boda: cree un bote, cada uno participa desde 10 € y la persona recibe una sola tarjeta con todos los mensajes.',
    it: "Festa d'addio, compleanno, matrimonio: crea una colletta, ognuno partecipa da 10 € e il festeggiato riceve una sola carta con tutti i messaggi.",
    de: 'Abschied, Geburtstag, Hochzeit: Starten Sie eine Sammelkasse, jeder gibt ab 10 €, und die beschenkte Person erhält eine Karte mit allen Nachrichten.',
    nl: 'Afscheid, verjaardag, bruiloft: start een pot, iedereen doet mee vanaf € 10 en de ontvanger krijgt één kaart met alle berichten.',
  },
  landingCta: {
    id: `${giftPotScope}.landingCta`,
    defaultMessage: 'Créer une cagnotte',
    en: 'Create a gift pot',
    es: 'Crear un bote',
    it: 'Crea una colletta',
    de: 'Sammelkasse anlegen',
    nl: 'Pot aanmaken',
  },
  seoMetaTitle: {
    id: `${giftPotScope}.seoMetaTitle`,
    defaultMessage: 'Cagnotte {occasion} : offrez un voyage à plusieurs',
    en: '{occasion} gift pot: give a trip together',
    es: 'Bote de {occasion}: regalen un viaje entre varios',
    it: 'Colletta {occasion}: regalate un viaggio insieme',
    de: 'Sammelkasse {occasion}: gemeinsam eine Reise schenken',
    nl: 'Pot {occasion}: geef samen een reis cadeau',
  },
  seoMetaDescription: {
    id: `${giftPotScope}.seoMetaDescription`,
    defaultMessage:
      'Cagnotte {occasion} en ligne : chacun participe dès 10 €, laisse un mot, et le bénéficiaire reçoit une carte cadeau Tictactrip pour voyager en train ou en bus. Création gratuite.',
    en: 'Online {occasion} gift pot: everyone chips in from €10 and leaves a message, and the recipient gets a Tictactrip gift card for train or bus trips. Free to create.',
    es: 'Bote de {occasion} en línea: cada uno participa desde 10 €, deja un mensaje y la persona recibe una tarjeta regalo Tictactrip para viajar en tren o autobús. Creación gratuita.',
    it: 'Colletta {occasion} online: ognuno partecipa da 10 €, lascia un messaggio e il festeggiato riceve una carta regalo Tictactrip per viaggiare in treno o autobus. Creazione gratuita.',
    de: 'Online-Sammelkasse {occasion}: Jeder gibt ab 10 € und hinterlässt eine Nachricht, die beschenkte Person erhält eine Tictactrip-Geschenkkarte für Zug- oder Busreisen. Kostenlos anlegen.',
    nl: 'Online pot {occasion}: iedereen doet mee vanaf € 10 en laat een bericht achter, en de ontvanger krijgt een Tictactrip-cadeaukaart voor trein- of busreizen. Gratis aanmaken.',
  },
  departTitle: {
    id: `${giftPotScope}.departTitle`,
    defaultMessage: 'Une cagnotte de pot de départ qui fait voyager',
    en: 'A farewell gift pot that takes them travelling',
    es: 'Un bote de despedida que hace viajar',
    it: "Una colletta d'addio che fa viaggiare",
    de: 'Eine Abschieds-Sammelkasse, die auf Reisen schickt',
    nl: 'Een afscheidspot die op reis stuurt',
  },
  departText: {
    id: `${giftPotScope}.departText`,
    defaultMessage:
      "Un collègue s'en va ? Réunissez l'équipe autour d'une carte cadeau Tictactrip : chacun participe dès 10 €, laisse un mot, et la carte arrive le jour du pot.",
    en: 'A colleague is leaving? Bring the team together around a Tictactrip gift card: everyone chips in from €10, leaves a message, and the card arrives on the day of the farewell.',
    es: '¿Se va un compañero? Reúna al equipo en torno a una tarjeta regalo Tictactrip: cada uno participa desde 10 €, deja un mensaje y la tarjeta llega el día de la despedida.',
    it: 'Un collega se ne va? Riunisci il team attorno a una carta regalo Tictactrip: ognuno partecipa da 10 €, lascia un messaggio e la carta arriva il giorno della festa.',
    de: 'Ein Kollege geht? Bringen Sie das Team um eine Tictactrip-Geschenkkarte zusammen: Jeder gibt ab 10 €, hinterlässt eine Nachricht, und die Karte kommt am Tag des Abschieds.',
    nl: 'Gaat een collega weg? Breng het team samen rond een Tictactrip-cadeaukaart: iedereen doet mee vanaf € 10, laat een bericht achter en de kaart komt op de dag van het afscheid.',
  },
  anniversaireTitle: {
    id: `${giftPotScope}.anniversaireTitle`,
    defaultMessage: "Une cagnotte d'anniversaire pour offrir un voyage",
    en: 'A birthday gift pot to give a trip',
    es: 'Un bote de cumpleaños para regalar un viaje',
    it: 'Una colletta di compleanno per regalare un viaggio',
    de: 'Eine Geburtstags-Sammelkasse, um eine Reise zu schenken',
    nl: 'Een verjaardagspot om een reis cadeau te geven',
  },
  anniversaireText: {
    id: `${giftPotScope}.anniversaireText`,
    defaultMessage:
      'Amis, famille, collègues : chacun participe en ligne dès 10 €. Le jour J, la carte cadeau arrive avec tous les messages.',
    en: 'Friends, family, colleagues: everyone chips in online from €10. On the day, the gift card arrives with every message.',
    es: 'Amigos, familia, compañeros: cada uno participa en línea desde 10 €. El día señalado, la tarjeta regalo llega con todos los mensajes.',
    it: 'Amici, famiglia, colleghi: ognuno partecipa online da 10 €. Il giorno stesso, la carta regalo arriva con tutti i messaggi.',
    de: 'Freunde, Familie, Kollegen: Jeder gibt online ab 10 €. Am Tag selbst kommt die Geschenkkarte mit allen Nachrichten.',
    nl: "Vrienden, familie, collega's: iedereen doet online mee vanaf € 10. Op de dag zelf komt de cadeaukaart met alle berichten.",
  },
  mariageTitle: {
    id: `${giftPotScope}.mariageTitle`,
    defaultMessage: 'Une cagnotte de mariage pour le voyage de noces',
    en: 'A wedding gift pot for the honeymoon',
    es: 'Un bote de boda para el viaje de novios',
    it: 'Una colletta di matrimonio per il viaggio di nozze',
    de: 'Eine Hochzeits-Sammelkasse für die Hochzeitsreise',
    nl: 'Een huwelijkspot voor de huwelijksreis',
  },
  mariageText: {
    id: `${giftPotScope}.mariageText`,
    defaultMessage:
      'Les invités financent ensemble le voyage des mariés, en train ou en bus, partout en France et en Europe. Les mots de chacun arrivent avec la carte.',
    en: "Guests fund the couple's trip together, by train or bus, anywhere in France and Europe. Everyone's messages arrive with the card.",
    es: 'Los invitados financian juntos el viaje de los novios, en tren o autobús, por toda Francia y Europa. Los mensajes de cada uno llegan con la tarjeta.',
    it: 'Gli invitati finanziano insieme il viaggio degli sposi, in treno o autobus, in tutta la Francia e in Europa. I messaggi di ognuno arrivano con la carta.',
    de: 'Die Gäste finanzieren gemeinsam die Reise des Paares, mit Zug oder Bus, in ganz Frankreich und Europa. Die Nachrichten aller kommen mit der Karte.',
    nl: 'De gasten betalen samen de reis van het bruidspaar, met de trein of de bus, in heel Frankrijk en Europa. Ieders berichten komen met de kaart.',
  },
  naissanceTitle: {
    id: `${giftPotScope}.naissanceTitle`,
    defaultMessage:
      'Une cagnotte de naissance pour les premiers voyages en famille',
    en: 'A new baby gift pot for the first family trips',
    es: 'Un bote de nacimiento para los primeros viajes en familia',
    it: 'Una colletta di nascita per i primi viaggi in famiglia',
    de: 'Eine Sammelkasse zur Geburt für die ersten Familienreisen',
    nl: 'Een geboortepot voor de eerste reizen met het gezin',
  },
  naissanceText: {
    id: `${giftPotScope}.naissanceText`,
    defaultMessage:
      'Offrez aux jeunes parents les trajets pour présenter bébé à la famille. Chacun participe dès 10 €, en ligne.',
    en: 'Give the new parents the trips to introduce the baby to the family. Everyone chips in from €10, online.',
    es: 'Regale a los nuevos padres los trayectos para presentar al bebé a la familia. Cada uno participa desde 10 €, en línea.',
    it: 'Regala ai neogenitori i viaggi per presentare il bebè alla famiglia. Ognuno partecipa da 10 €, online.',
    de: 'Schenken Sie den jungen Eltern die Reisen, um das Baby der Familie vorzustellen. Jeder gibt online ab 10 €.',
    nl: 'Geef de jonge ouders de reizen om de baby aan de familie voor te stellen. Iedereen doet online mee vanaf € 10.',
  },
  retraiteTitle: {
    id: `${giftPotScope}.retraiteTitle`,
    defaultMessage: 'Une cagnotte de départ à la retraite pour enfin voyager',
    en: 'A retirement gift pot to finally travel',
    es: 'Un bote de jubilación para viajar por fin',
    it: 'Una colletta per la pensione per viaggiare finalmente',
    de: 'Eine Ruhestands-Sammelkasse, um endlich zu reisen',
    nl: 'Een pensioenpot om eindelijk te reizen',
  },
  retraiteText: {
    id: `${giftPotScope}.retraiteText`,
    defaultMessage:
      "Pour un départ en retraite, l'équipe offre le temps de voyager : une carte cadeau valable 1 an, avec les mots de tous.",
    en: "For a retirement, the team gives the time to travel: a gift card valid 1 year, with everyone's messages.",
    es: 'Para una jubilación, el equipo regala tiempo para viajar: una tarjeta regalo válida 1 año, con los mensajes de todos.',
    it: 'Per un pensionamento, il team regala il tempo per viaggiare: una carta regalo valida 1 anno, con i messaggi di tutti.',
    de: 'Zum Ruhestand schenkt das Team Zeit zum Reisen: eine Geschenkkarte, 1 Jahr gültig, mit den Nachrichten aller.',
    nl: 'Bij een pensioen geeft het team tijd om te reizen: een cadeaukaart, 1 jaar geldig, met ieders berichten.',
  },
  noelTitle: {
    id: `${giftPotScope}.noelTitle`,
    defaultMessage: 'Une cagnotte de Noël pour un voyage à plusieurs',
    en: 'A Christmas gift pot for a trip from many',
    es: 'Un bote de Navidad para un viaje entre varios',
    it: 'Una colletta di Natale per un viaggio di gruppo',
    de: 'Eine Weihnachts-Sammelkasse für eine gemeinsame Reise',
    nl: 'Een kerstpot voor een reis van meerdere mensen',
  },
  noelText: {
    id: `${giftPotScope}.noelText`,
    defaultMessage:
      'Frères, sœurs, cousins : réunissez-vous pour offrir un voyage. La carte peut arriver le 25 décembre au matin.',
    en: 'Brothers, sisters, cousins: get together to give a trip. The card can arrive on the morning of 25 December.',
    es: 'Hermanos, hermanas, primos: únanse para regalar un viaje. La tarjeta puede llegar la mañana del 25 de diciembre.',
    it: 'Fratelli, sorelle, cugini: unitevi per regalare un viaggio. La carta può arrivare la mattina del 25 dicembre.',
    de: 'Geschwister, Cousins: Tun Sie sich zusammen und schenken Sie eine Reise. Die Karte kann am Morgen des 25. Dezember ankommen.',
    nl: 'Broers, zussen, neven: sla de handen ineen en geef een reis cadeau. De kaart kan op de ochtend van 25 december aankomen.',
  },
  how1Title: {
    id: `${giftPotScope}.how1Title`,
    defaultMessage: 'Créez la cagnotte',
    en: 'Create the pot',
    es: 'Cree el bote',
    it: 'Crea la colletta',
    de: 'Sammelkasse anlegen',
    nl: 'Maak de pot aan',
  },
  how1Text: {
    id: `${giftPotScope}.how1Text`,
    defaultMessage:
      "Choisissez l'occasion, le thème de la carte et la date de remise. C'est gratuit.",
    en: "Choose the occasion, the card's theme and the handover date. It's free.",
    es: 'Elija la ocasión, el tema de la tarjeta y la fecha de entrega. Es gratis.',
    it: "Scegli l'occasione, il tema della carta e la data di consegna. È gratis.",
    de: 'Wählen Sie Anlass, Motiv der Karte und Übergabedatum. Es ist kostenlos.',
    nl: 'Kies de gelegenheid, het thema van de kaart en de datum. Het is gratis.',
  },
  how2Title: {
    id: `${giftPotScope}.how2Title`,
    defaultMessage: 'Partagez le lien',
    en: 'Share the link',
    es: 'Comparta el enlace',
    it: 'Condividi il link',
    de: 'Link teilen',
    nl: 'Deel de link',
  },
  how2Text: {
    id: `${giftPotScope}.how2Text`,
    defaultMessage:
      'Par WhatsApp ou par email : chacun participe dès 10 € et laisse un mot.',
    en: 'By WhatsApp or email: everyone chips in from €10 and leaves a message.',
    es: 'Por WhatsApp o por email: cada uno participa desde 10 € y deja un mensaje.',
    it: 'Via WhatsApp o email: ognuno partecipa da 10 € e lascia un messaggio.',
    de: 'Per WhatsApp oder E-Mail: Jeder gibt ab 10 € und hinterlässt eine Nachricht.',
    nl: 'Via WhatsApp of e-mail: iedereen doet mee vanaf € 10 en laat een bericht achter.',
  },
  how3Title: {
    id: `${giftPotScope}.how3Title`,
    defaultMessage: 'La carte part le jour J',
    en: 'The card leaves on the day',
    es: 'La tarjeta sale el día señalado',
    it: 'La carta parte il giorno stesso',
    de: 'Die Karte geht am Tag selbst los',
    nl: 'De kaart vertrekt op de dag zelf',
  },
  how3Text: {
    id: `${giftPotScope}.how3Text`,
    defaultMessage:
      "Le bénéficiaire reçoit une carte cadeau du total, avec le livre d'or de tous les messages.",
    en: 'The recipient gets a gift card for the total, with a guest book of every message.',
    es: 'La persona recibe una tarjeta regalo por el total, con el libro de todos los mensajes.',
    it: 'Il festeggiato riceve una carta regalo del totale, con il libro di tutti i messaggi.',
    de: 'Die beschenkte Person erhält eine Geschenkkarte über den Gesamtbetrag, mit einem Gästebuch aller Nachrichten.',
    nl: 'De ontvanger krijgt een cadeaukaart voor het totaal, met een gastenboek van alle berichten.',
  },
  faq1Q: {
    id: `${giftPotScope}.faq1Q`,
    defaultMessage: 'La création de la cagnotte est-elle payante ?',
    en: 'Does creating the pot cost anything?',
    es: '¿Crear el bote tiene coste?',
    it: 'Creare la colletta è a pagamento?',
    de: 'Kostet das Anlegen der Sammelkasse etwas?',
    nl: 'Kost het aanmaken van de pot iets?',
  },
  faq1A: {
    id: `${giftPotScope}.faq1A`,
    defaultMessage:
      "Non, c'est gratuit. Chaque participant paie seulement sa participation, dès 10 €.",
    en: "No, it's free. Each participant only pays their contribution, from €10.",
    es: 'No, es gratis. Cada participante solo paga su participación, desde 10 €.',
    it: 'No, è gratis. Ogni partecipante paga solo la sua partecipazione, da 10 €.',
    de: 'Nein, es ist kostenlos. Jeder zahlt nur seinen Beitrag, ab 10 €.',
    nl: 'Nee, het is gratis. Elke deelnemer betaalt alleen zijn bijdrage, vanaf € 10.',
  },
  faq2Q: {
    id: `${giftPotScope}.faq2Q`,
    defaultMessage: 'Que reçoit le bénéficiaire ?',
    en: 'What does the recipient get?',
    es: '¿Qué recibe la persona?',
    it: 'Che cosa riceve il festeggiato?',
    de: 'Was erhält die beschenkte Person?',
    nl: 'Wat krijgt de ontvanger?',
  },
  faq2A: {
    id: `${giftPotScope}.faq2A`,
    defaultMessage:
      "Une carte cadeau Tictactrip du montant total, valable 1 an, pour des trajets en train ou en bus, avec un livre d'or de tous les messages.",
    en: 'A Tictactrip gift card for the full amount, valid 1 year, for train or bus trips, with a guest book of every message.',
    es: 'Una tarjeta regalo Tictactrip por el importe total, válida 1 año, para trayectos en tren o autobús, con un libro de todos los mensajes.',
    it: "Una carta regalo Tictactrip dell'importo totale, valida 1 anno, per viaggi in treno o autobus, con un libro di tutti i messaggi.",
    de: 'Eine Tictactrip-Geschenkkarte über den Gesamtbetrag, 1 Jahr gültig, für Zug- oder Busreisen, mit einem Gästebuch aller Nachrichten.',
    nl: 'Een Tictactrip-cadeaukaart voor het totale bedrag, 1 jaar geldig, voor trein- of busreizen, met een gastenboek van alle berichten.',
  },
  faq3Q: {
    id: `${giftPotScope}.faq3Q`,
    defaultMessage: "Et s'il n'a pas d'email ?",
    en: 'What if they have no email?',
    es: '¿Y si no tiene email?',
    it: "E se non ha un'email?",
    de: 'Und wenn sie keine E-Mail hat?',
    nl: 'En als die geen e-mail heeft?',
  },
  faq3A: {
    id: `${giftPotScope}.faq3A`,
    defaultMessage:
      "La carte et le livre d'or arrivent chez l'organisateur, en PDF à imprimer.",
    en: 'The card and the guest book go to the organizer, as a PDF to print.',
    es: 'La tarjeta y el libro llegan al organizador, en PDF para imprimir.',
    it: "La carta e il libro arrivano all'organizzatore, in PDF da stampare.",
    de: 'Karte und Gästebuch gehen als PDF zum Ausdrucken an die organisierende Person.',
    nl: 'De kaart en het gastenboek gaan naar de organisator, als pdf om af te drukken.',
  },
  faq4Q: {
    id: `${giftPotScope}.faq4Q`,
    defaultMessage: 'Peut-on cacher le montant ?',
    en: 'Can the amount be hidden?',
    es: '¿Se puede ocultar el importe?',
    it: "Si può nascondere l'importo?",
    de: 'Kann man den Betrag verbergen?',
    nl: 'Kan het bedrag verborgen worden?',
  },
  faq4A: {
    id: `${giftPotScope}.faq4A`,
    defaultMessage:
      "Oui. L'organisateur choisit si le total est visible, et chaque participant peut masquer son montant ou son nom.",
    en: 'Yes. The organizer chooses whether the total shows, and each participant can hide their amount or their name.',
    es: 'Sí. El organizador elige si el total es visible y cada participante puede ocultar su importe o su nombre.',
    it: "Sì. L'organizzatore sceglie se il totale è visibile e ogni partecipante può nascondere il suo importo o il suo nome.",
    de: 'Ja. Die organisierende Person entscheidet, ob der Gesamtbetrag sichtbar ist, und jeder kann seinen Betrag oder Namen verbergen.',
    nl: 'Ja. De organisator kiest of het totaal zichtbaar is en elke deelnemer kan zijn bedrag of naam verbergen.',
  },
  faq5Q: {
    id: `${giftPotScope}.faq5Q`,
    defaultMessage: 'Et si la cagnotte est annulée ?',
    en: 'What if the pot is cancelled?',
    es: '¿Y si el bote se cancela?',
    it: 'E se la colletta viene annullata?',
    de: 'Und wenn die Sammelkasse abgesagt wird?',
    nl: 'En als de pot wordt geannuleerd?',
  },
  faq5A: {
    id: `${giftPotScope}.faq5A`,
    defaultMessage:
      "Tant que la carte n'est pas envoyée, l'organisateur peut annuler : chacun est remboursé sur sa carte bancaire.",
    en: 'Until the card is sent, the organizer can cancel: everyone is refunded on their bank card.',
    es: 'Mientras la tarjeta no se haya enviado, el organizador puede cancelar: cada uno es reembolsado en su tarjeta bancaria.',
    it: "Finché la carta non è inviata, l'organizzatore può annullare: ognuno è rimborsato sulla sua carta bancaria.",
    de: 'Solange die Karte nicht gesendet ist, kann abgesagt werden: Jeder erhält sein Geld auf die Bankkarte zurück.',
    nl: 'Zolang de kaart niet is verzonden, kan de organisator annuleren: iedereen wordt terugbetaald op zijn bankkaart.',
  },
  faqTitle: {
    id: `${giftPotScope}.faqTitle`,
    defaultMessage: 'Questions fréquentes',
    en: 'Frequently asked questions',
    es: 'Preguntas frecuentes',
    it: 'Domande frequenti',
    de: 'Häufige Fragen',
    nl: 'Veelgestelde vragen',
  },
  otherOccasions: {
    id: `${giftPotScope}.otherOccasions`,
    defaultMessage: 'Une cagnotte pour une autre occasion',
    en: 'A gift pot for another occasion',
    es: 'Un bote para otra ocasión',
    it: "Una colletta per un'altra occasione",
    de: 'Eine Sammelkasse für einen anderen Anlass',
    nl: 'Een pot voor een andere gelegenheid',
  },
};
